import { useContext } from 'react';
import { DetailsBookingContext } from 'components/DetailsBookingProvider';

export const useDetailsBooking = () => {
  const { booking, refetch } = useContext(DetailsBookingContext);

  if (!booking) {
    throw new Error('useDetailsBooking() can only be used under <DetailsBookingProvider />');
  }

  return { booking, refetch };
};
